module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "pdf.worker.68c59c6a8a0dc177666c.js");
}
